import * as React from "react";
const SvgKeyboardDoubleArrowLeft = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.59 18 19 16.59 14.42 12 19 7.41 17.59 6l-6 6z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "m11 18 1.41-1.41L7.83 12l4.58-4.59L11 6l-6 6z",
  fill: "currentColor"
}));
export default SvgKeyboardDoubleArrowLeft;